import { AlertTriangle } from 'lucide-react';
import { ErrorBannerWrapper, ErrorBannerContent, ErrorBannerIcon, ErrorBannerText } from './styled';

export interface AuthErrorBannerProps {
  error: string;
}

/**
 * Error message banner for authentication forms.
 */
export function AuthErrorBanner({ error }: { error?: string }) {
  if (!error) {
    return null;
  }

  return (
    <ErrorBannerWrapper>
      <ErrorBannerContent>
        <ErrorBannerIcon>
          <AlertTriangle />
        </ErrorBannerIcon>
        <ErrorBannerText>{error}</ErrorBannerText>
      </ErrorBannerContent>
    </ErrorBannerWrapper>
  );
}
